export const TEST_META_ACTIONS = {
  'SET_HEADER_DISPLAY_CONFIG': 'TEST_META_SET_HEADER_DISPLAY_CONFIG'
};
